import { FormFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: FormFields = [
  {
    name: "registrationTime",
    title: $t("Registration Date"),
    type: "date"
  },
  {
    name: "registrationIp",
    title: $t("Registration IP")
  },
  {
    name: "lastLoginTime",
    title: $t("Last Login Date"),
    type: "date"
  },
  {
    name: "lastLoginIp",
    title: $t("Last Login IP")
  },
  {
    name: "referralUrl",
    title: $t("Referral URL")
  },
  {
    name: "lastOnlineTime",
    title: $t("Last Online Time")
  },
];
